module.exports = {"major":"2","minor":"0","build":"04:47:26+14-12-19"}


//////////////////
// WEBPACK FOOTER
// ./src/version.json
// module id = 1329
// module chunks = 0